import React, { useMemo } from "react";
import logo from "Assets/Images/LoginPage/skillsbridge_logo_with_text.png";
import loginPageImage1 from "Assets/Images/LoginPage/login_page_image_1.png";
import loginPageImage2 from "Assets/Images/LoginPage/login_page_image_2.png";
import {
  LoginPageStyled,
  LoginLeftStyled,
  LoginRightStyled,
  LoginPageImageStyled,
  LogoStyled,
  HeadingStyled,
} from "Pages/SbAuthPage/LoginV2.styles";

const LOGIN_PAGE_IMAGES = [loginPageImage1, loginPageImage2];

// Shared layout for the auth pages — the background, logo, heading and login-page image render
// ONCE and stay mounted. Login / Sign up / Forgot password each pass only their form as children,
// so switching between them re-renders just the form (the image never reloads).
// The image is picked at random once per visit (useMemo [] = chosen on mount, then stays).
const LoginPageLayout = ({ children }) => {
  const loginPageImage = useMemo(
    () => LOGIN_PAGE_IMAGES[Math.floor(Math.random() * LOGIN_PAGE_IMAGES.length)],
    []
  );

  return (
    <LoginPageStyled>
      <LoginLeftStyled>
        <LogoStyled src={logo} alt="skillsbridge.ai" />
        <HeadingStyled>The future of work needs a blueprint</HeadingStyled>
        {children}
      </LoginLeftStyled>
      <LoginRightStyled>
        <LoginPageImageStyled src={loginPageImage} alt="" />
      </LoginRightStyled>
    </LoginPageStyled>
  );
};

export default LoginPageLayout;
